import axios from 'axios';

export default axios.create({
  baseURL: 'https://zapis.onehublink.com/api'
});

export const axiosPrivate = axios.create({
  baseURL: 'https://zapis.onehublink.com/api',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});
